/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyEventDetailBookingDialogController', DinghyEventDetailBookingDialogController);

    DinghyEventDetailBookingDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'entityBooking', 'DinghyDetailBooking'];

    function DinghyEventDetailBookingDialogController ($timeout, $scope, $uibModalInstance, entity, entityBooking, DinghyDetailBooking) {
        var vm = this;

        vm.dinghyEvent = entity;
        vm.booking = entityBooking;
        vm.nickname = vm.booking.profile.nickname ? " \"" + vm.booking.profile.nickname + "\"" : "";
        vm.isNewBooking = vm.booking.bookingStatus == null;
        if (!vm.isNewBooking) {
            vm.oldBookingStatus = vm.booking.bookingStatus;
            vm.booking.sendNotificationMail = true;
        }
        vm.clear = clear;
        vm.save = save;

        if (vm.isNewBooking
            && (vm.dinghyEvent.canceled || vm.dinghyEvent.closed || !vm.dinghyEvent.active || !vm.dinghyEvent.allowGuests || (vm.dinghyEvent.guestPrice && vm.dinghyEvent.guestPrice > 0))) {
            // same check as for the new button
            // ng-if="vm.allowGuests && (!vm.dinghyEvent.guestPrice || vm.dinghyEvent.guestPrice == 0)"
            // ng-disabled="vm.isSaving || vm.dinghyEvent.canceled || vm.dinghyEvent.closed || !vm.dinghyEvent.active"
            $timeout(function() {
                clear();
            });
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.isNewBooking) {
                DinghyDetailBooking.save(vm.booking, onSaveSuccess, onSaveError);
            } else {
                DinghyDetailBooking.update(vm.booking, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            if (vm.isNewBooking) {
                $scope.$emit('askApp:dinghyBookingUpdate', result);
            } else {
                $scope.$emit('askApp:dinghyBookingCreate', result);
            }
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();
